// ** Third Party Components
import styled from "styled-components";

// #####################################################

export const StyledCommentContainer = styled.div`
	margin-top: 0.75rem;

	&:first-child {
		margin-top: 0;
	}
`;

// #####################################################
